
const digest = '4e3896d52192d51565db32c851e1f34bf7277bf20826c12c1047fc8d33602dfc';
const classes = {"wrapper":"_wrapper_yo42j_1","toggleButton":"_toggleButton_yo42j_4","badge":"_badge_yo42j_17"};
const css = `._wrapper_yo42j_1 {
  position: relative;
}
._wrapper_yo42j_1 ._toggleButton_yo42j_4 {
  display: flex;
  cursor: pointer;
  border-radius: 100%;
  background-color: #1452ac;
  font-size: 16px;
  position: relative;
  color: #fff;
  width: 42px;
  height: 42px;
  text-align: center;
  line-height: 44px;
}
._wrapper_yo42j_1 ._badge_yo42j_17 {
  background-color: #f12848;
  color: #fff;
  position: absolute;
  border-radius: 4px;
  top: 0;
  right: -6px;
  padding: 1px 6px;
  font-size: 12px;
  font-weight: 500;
  font-family: Rubik, sans-serif;
  line-height: 18px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  